import * as React from "react";
import { cn } from "@/lib/utils";

type BadgeVariant = "default" | "credit" | "payable" | "danger" | "outline" | "muted";

const variants: Record<BadgeVariant, string> = {
  default: "bg-primary text-primary-ink",
  credit: "bg-credit text-white",
  payable: "bg-payable text-white",
  danger: "bg-danger text-white",
  outline: "border border-border bg-white text-ink",
  muted: "bg-surface-strong text-muted",
};

export function Badge({
  variant = "default",
  className,
  ...props
}: React.HTMLAttributes<HTMLSpanElement> & { variant?: BadgeVariant }) {
  return (
    <span
      className={cn("inline-flex min-h-7 w-fit max-w-full items-center whitespace-nowrap rounded-full px-2.5 text-xs font-semibold", variants[variant], className)}
      {...props}
    />
  );
}
